module.exports = __webpack_public_path__ + "img/product-4.4c692587.jpg";